import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import Chat from "@/pages/Chat";

export const Route = createFileRoute("/_app/chat")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="chat">
      <Chat />
    </ModuleGuard>
  );
}
